// import React from 'react'
// import Navbar from '../../components/Navbar'
// import BottomContent from '../../components/BottomContent'
// import Hero from './Hero'
// import HeroImg from '../../assets/img/DigitalHero.png'
// import ScrollButton from "../../components/ScrollButton"
// import { Link } from 'react-router-dom'
// import ContactButton from '../../components/ContactButton'
// import DarkModeButton from '../../components/DarkModeButton'
// import Thank from '../../components/Thank'
// import { FaLightbulb, FaRobot, FaBrain, FaShieldAlt, FaComments, FaNetworkWired } from 'react-icons/fa';


// export default function Digital() {
//   const HeroImgDigital = {
//     heading: 'Digital Strategy and Innovation',
//     subheading: 'Revolutionizing Businesses with Advanced Digital Solutions',
//     text: Harness the power of innovation to elevate your business with our comprehensive digital strategy services. From AI-driven automation to state-of-the-art engineering practices, we equip your organization with the most advanced technologies and transformative solutions.,
//     img: HeroImg,
//     validate: false
//   }

//   // Service data with icons instead of images
//   const digitalServices = [
//     {
//       icon: <FaLightbulb size={32} />,
//       heading: 'Digital Strategy and Innovation',
//       text: Reimagine your business with our innovative digital strategy solutions. Leverage cutting-edge technologies to foster transformation and maintain a competitive edge. Our experts work alongside you to develop a strategic roadmap that seamlessly integrates digital innovation with your business objectives.,
//     },
//     {
//       icon: <FaRobot size={32} />,
//       heading: 'AI Automation Practices - RPA/CPA',
//       text: Automate repetitive tasks and enhance operational efficiency with our AI-driven automation solutions. We implement Robotic Process Automation (RPA) and Cognitive Process Automation (CPA) to streamline workflows and reduce manual effort, enabling smarter and faster decision-making.,

//     },
//     {
//       icon: <FaBrain size={32} />,
//       heading: 'AI Data Science Practices - DS/ML/DL, GenAI',
//       text: Leverage the power of data with our advanced data science and machine learning practices. From predictive analytics to generative AI, we develop data-driven solutions that provide valuable insights and support strategic decision-making.,
    
//     },
//     {
//       icon: <FaShieldAlt size={32} />,
//       heading: 'Quantum Computing & Cybersecurity',
//       text: Stay ahead in the digital age with cutting-edge quantum computing and robust cybersecurity solutions. Our experts ensure that your data and systems are protected while exploring new computational possibilities with quantum technology.,
      
//     },
//     {
//       icon: <FaComments size={32} />,
//       heading: 'Chatbot Solutions',
//       text: Boost customer engagement and streamline support with smart chatbot solutions. We develop AI-powered conversational systems that effectively interpret and respond to user inquiries, delivering smooth and efficient interactions to elevate user experience.,
//     },
//     {
//       icon: <FaNetworkWired size={32} />,
//       heading: 'Blockchain & IoT Practices',
//       text: Secure your data and connect your devices with our blockchain and IoT solutions. We develop decentralized applications and integrate IoT frameworks to create secure, reliable, and efficient ecosystems for your business.,
      
//     }
//   ]

//   return (
//     <>
//       <Navbar />
//       <Hero
//         heading={HeroImgDigital.heading}
//         subheading={HeroImgDigital.subheading}
//         text={HeroImgDigital.text}
//         img={HeroImg}
//         validate={HeroImgDigital.validate}
//       />

//       {/* Services Section - Modern Card Layout */}
//       <div className="container py-5">        
//         <div className="row g-4">
//           {digitalServices.map((service, index) => (
//             <div className="col-md-6 mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
//               <div className="card h-100 border-0 shadow-sm">
//                 <div className="card-body p-4">
//                   {/* <div className={icon-circle bg-light bg-opacity-10 mb-4} style={{
//                     width: '50px',
//                     height: '50px',
//                     borderRadius: '50%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     color: black,
//                   }}>
//                     {service.icon}
//                   </div> */}
//                   <h3 className={h4 mb-3 fw-bold}>{service.heading}</h3>
//                   <p className="text-muted mb-3">{service.text}</p>
//                   <Link to="/scheduledemo" className="btn btn-sm btn-outline-primary">
//                       Learn More
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>


//       {/* Call to Action Section - Improved */}
//       <section className='' >
//         <div className="p-5 text-center" style={{ backgroundColor: '#3BB893' }} data-aos="fade-up" data-aos-anchor-placement="top-center">
//           <h3 className='text-light'>Having Projects ?</h3>
//           <p className='text-light'>Schedule a Free Demo and Start Business you always Dream.</p>
//           <div className="button">
//             <button className='btn'><Link style={{ textDecoration: 'none', color: 'green' }} to='/scheduledemo'>Schedule Demo</Link></button>
//           </div>
//         </div>
//       </section>

//       <Thank />
//       <ContactButton />
//       <BottomContent />
//       <DarkModeButton />
//       <ScrollButton/>
      
//       {/* Custom CSS */}
//       <style>{
//         .card {
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//           box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//           border-radius: 12px;
//           background: var(--card_color);
//           color: var(--heading_color);
          
//         }
//         .card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
//         }
//       }</style>
//     </>
//   )
// }

import React from 'react';
import Navbar from '../../components/Navbar';
import BottomContent from '../../components/BottomContent';
import Hero from '../Hero';
import HeroImg from '../../assets/ServicesImg/DigitalHero.jpg';
import ScrollButton from '../../components/ScrollButton';
import { Link } from 'react-router-dom';
import ContactButton from '../../components/ContactButton';
import DarkModeButton from '../../components/DarkModeButton';
import Thank from '../../components/Thank';

// Import service images
import DigitalStrategyImg from '../../assets/ServicesImg/Digital-Strategy.webp';
import AIImg from '../../assets/ServicesImg/AI-Automation.webp';
import DataScienceImg from '../../assets/ServicesImg/Data-Science.webp';
import CybersecurityImg from '../../assets/ServicesImg/Cyber-Security.webp';
import ChatbotImg from '../../assets/ServicesImg/Chat-Bot.webp';
import BlockchainImg from '../../assets/ServicesImg/Block-Chain.webp';

export default function Digital() {
  const HeroDigital = {
    heading: 'Digital Strategy and Innovation',
    subheading: 'Revolutionizing Businesses with Advanced Digital Solutions',
    des: `Harness the power of innovation to elevate your business with our comprehensive digital strategy services. From AI-driven automation to state-of-the-art engineering practices, we equip your organization with the most advanced technologies and transformative solutions.`,
    img: HeroImg
  };

  // Service data with images instead of icons
  const digitalServices = [
    {
      image: DigitalStrategyImg,
      heading: 'Digital Strategy and Innovation',
      text: `Reimagine your business with our innovative digital strategy solutions. Leverage cutting-edge technologies to foster transformation and maintain a competitive edge. Our experts work alongside you to develop a strategic roadmap that seamlessly integrates digital innovation with your business objectives.`,
    },
    {
      image: AIImg,
      heading: 'AI Automation Practices - RPA/CPA',
      text: `Automate repetitive tasks and enhance operational efficiency with our AI-driven automation solutions. We implement Robotic Process Automation (RPA) and Cognitive Process Automation (CPA) to streamline workflows and reduce manual effort, enabling smarter and faster decision-making.`,
    },
    {
      image: DataScienceImg,
      heading: 'AI Data Science Practices - DS/ML/DL, GenAI',
      text: `Leverage the power of data with our advanced data science and machine learning practices. From predictive analytics to generative AI, we develop data-driven solutions that provide valuable insights and support strategic decision-making.`,
    },
    {
      image: CybersecurityImg,
      heading: 'Quantum Computing & Cybersecurity',
      text: `Stay ahead in the digital age with cutting-edge quantum computing and robust cybersecurity solutions. Our experts ensure that your data and systems are protected while exploring new computational possibilities with quantum technology.`,
    },
    {
      image: ChatbotImg,
      heading: 'Chatbot Solutions',
      text: `Boost customer engagement and streamline support with smart chatbot solutions. We develop AI-powered conversational systems that effectively interpret and respond to user inquiries, delivering smooth and efficient interactions to elevate user experience.`,
    },
    {
      image: BlockchainImg,
      heading: 'Blockchain & IoT Practices',
      text: `Secure your data and connect your devices with our blockchain and IoT solutions. We develop decentralized applications and integrate IoT frameworks to create secure, reliable, and efficient ecosystems for your business.`,
    }
  ];

  return (
    <>
      <Navbar />
      <Hero
        heading={HeroDigital.heading}
        subheading={HeroDigital.subheading}
        des={HeroDigital.des}
        img={HeroImg}
      />

      <div className="container mt-5 mb-5">
        {digitalServices.map((digitalServices, index) => (
          <div className="row mb-5 align-items-center" key={index}>
              {/* Image */}
            <div className={`col-12 col-md-6 d-flex justify-content-center ${index % 2 === 0 ? "order-1 order-md-1" : "order-1 order-md-2"}`}>
              <img
                className="img-fluid"
                loading='lazy'
                src={digitalServices.image}
                alt={digitalServices.heading}
                style={{
                  maxWidth: "250px",
                  maxHeight: "250px",
                  width: "100%",
                  height: "auto",
                  borderRadius: "50px"
                }}
              />
            </div>

            {/* Text */}
                <div className={`col-12 col-md-6 text-center text-md-start ${index % 2 === 0 ? "order-2 order-md-2" : "order-2 order-md-1"}`}>
                  <h2 style={{ color: "var(--heading_color)",marginTop:'10px' }}>{digitalServices.heading}</h2>
                  <p className="fs-5 text-muted">{digitalServices.text}</p>
                </div>
          </div>
        ))}
      </div>

      {/* Call to Action Section */}
      <section className=''>
        <div className="p-5 text-center" style={{ backgroundColor: '#3BB893' }} data-aos="fade-up" data-aos-anchor-placement="top-center">
          <h3 className='text-light'>Having Projects?</h3>
          <p className='text-light'>Schedule a Free Demo and Start Business you always Dream.</p>
          <div className="button">
            <button className='btn'>
              <Link style={{ textDecoration: 'none', color: 'green' }} to='/scheduledemo'>Schedule Demo</Link>
            </button>
          </div>
        </div>
      </section>

      <Thank />
      <ContactButton />
      <BottomContent />
      <DarkModeButton />
      <ScrollButton />

      {/* Custom CSS */}
      <style>{`
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          background: var(--card_color);
          color: var(--heading_color);
        }
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </>
  );
}
